import React from 'react'
import BlockInfo from './BlockInfo'

const ContainerInfoWeeks = ({ totalsWeeks }) => {
    return (
        <div className='w-[450px] h-[90px] bg-white px-[16px] py-[12px] flex items-center'>
            <div className='w-[120px] flex flex-col items-center justify-center h-full'>
                <p className='text-[12px] font-bold'>Total de semanas de los proyectos del año</p>
            </div>
            <div className='w-[calc(100%-120px)] h-full grid grid-cols-4 gap-[4px]'>
                <BlockInfo title="Total" weeksNumber={null} orderBy="desc" isBorder={true}/>
                <BlockInfo title="Semanas estimadas" weeksNumber={totalsWeeks.weeksEstimate} isBorder={true}/>
                <BlockInfo title="Semanas trabajadas" weeksNumber={totalsWeeks.weeksWorked} isBorder={true}/>
                <BlockInfo title="Diferencia" weeksNumber={totalsWeeks.difference} />
            </div>
        </div>
    )
}

export default ContainerInfoWeeks